import React, { forwardRef } from 'react';
import cn from 'classnames';
import BaseButton from './BaseButton';

const HistoryGridButton = forwardRef(({ title = 'History', className, ...props }, ref) => {
  const btnClassName = cn('history-button', { [className]: className });
  return (
    <BaseButton
      ref={ref}
      id='history-button'
      responsive
      themeColor='info'
      className={btnClassName}
      icon='clock'
      title={title}
      {...props}
    />
  );
});

export default HistoryGridButton;
